import _objectSpread from "D:\\a\\1\\s\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread2";

/**
 * @typedef {import('../types.js').FlowContent} FlowContent
 * @typedef {import('../types.js').Node} Node
 * @typedef {import('../types.js').Parent} Parent
 * @typedef {import('../types.js').State} State
 * @typedef {import('../types.js').TrackFields} TrackFields
 */

/**
 * @param {Parent & {children: Array<FlowContent>}} parent
 *   Parent of flow nodes.
 * @param {State} state
 *   Info passed around about the current state.
 * @param {TrackFields} info
 *   Info on where we are in the document we are generating.
 * @returns {string}
 *   Serialized children, joined by (blank) lines.
 */
export function containerFlow(parent, state, info) {
  var indexStack = state.indexStack;
  var children = parent.children || [];
  var tracker = state.createTracker(info);
  /** @type {Array<string>} */

  var results = [];
  var index = -1;
  indexStack.push(-1);

  while (++index < children.length) {
    var child = children[index];
    indexStack[indexStack.length - 1] = index;
    results.push(tracker.move(state.handle(child, parent, state, _objectSpread({
      before: '\n',
      after: '\n'
    }, tracker.current()))));

    if (child.type !== 'list') {
      state.bulletLastUsed = undefined;
    }

    if (index < children.length - 1) {
      results.push(tracker.move(between(child, children[index + 1], parent, state)));
    }
  }

  indexStack.pop();
  return results.join('');
}
/**
 * @param {Node} left
 * @param {Node} right
 * @param {Parent} parent
 * @param {State} state
 * @returns {string}
 */

function between(left, right, parent, state) {
  var index = state.join.length;

  while (index--) {
    var result = state.join[index](left, right, parent, state);

    if (result === true || result === 1) {
      break;
    }

    if (typeof result === 'number') {
      return '\n'.repeat(1 + result);
    }

    if (result === false) {
      return '\n\n<!---->\n\n';
    }
  }

  return '\n\n';
}